import { Injectable } from '@angular/core';
import { getStatusText, InMemoryDbService, RequestInfo, ResponseOptions } from 'angular-in-memory-web-api';
import { Observable } from 'rxjs/Observable';
import { ServiceConfiguration } from './config';
import { switchMap } from 'rxjs/operators';

export enum HTTP_METHODS {
  GET = 'get',
  PUT = 'put',
  POST = 'post'
}

@Injectable()
export class InMemoryBackendMockService implements InMemoryDbService {

  private map: { [url: string]: { [method: string ]: (reqInfo: RequestInfo) => { }; }} = { };

  private initiatorMap: { [url: string]: () => { }; } = { };

  public registerInitiator(url: string, func: () => { }) {
    if (!this.initiatorMap[url]) {
      this.initiatorMap[url] = func;
      if (ServiceConfiguration.shouldInitMockData(url)) {
        console.warn('init mocked data in DB for ' + url);
        this.initiatorMap[url]();
      }
    }
  }

  public registerHandler(url: string, method: string, func: (reqInfo: RequestInfo) => { }) {
    if (!this.map[url]) {
      this.map[url] = { };
    }
    if (!this.map[url][method]) {
        this.map[url][method] = func;
    }
  }

  constructor() {
  }

  createDb() {
    return { };
  }

  isUrlRegistered(reqInfo: RequestInfo, url: string): boolean {
    return ServiceConfiguration.isMockBackEnd() && this.map[url] != null && this.map[url][reqInfo.method] != null;
  }

  navigate(reqInfo: RequestInfo) {
    let urlToMock;
    if (this.isUrlRegistered(reqInfo, reqInfo.resourceUrl)) { // todo validate
      urlToMock = reqInfo.resourceUrl;
    }
    if (this.isUrlRegistered(reqInfo, reqInfo.url)) { // todo validate
      urlToMock = reqInfo.url;
    }
    const urlBasic = reqInfo.apiBase.split('/')[0];
    if (this.isUrlRegistered(reqInfo, urlBasic)) { // todo validate
      urlToMock = urlBasic;
    }
    if (urlToMock && ServiceConfiguration.shouldMockSpecificURL(urlToMock)) {
      console.warn(`please notice that Data is mocked. ${reqInfo.method}:${urlToMock}`);
      return this.returnWrapper(reqInfo, this.map[urlToMock][reqInfo.method](reqInfo));
    }

    return reqInfo.utils.getPassThruBackend().handle(reqInfo.req);
  }

  get(reqInfo: RequestInfo) {
   return this.navigate(reqInfo);
  }

  post(reqInfo: RequestInfo) {
    return this.navigate(reqInfo);
  }

  put(reqInfo: RequestInfo) {
    return this.navigate(reqInfo);
  }

  public returnWrapper(reqInfo: RequestInfo, data: any): Observable<any> {
    if (data instanceof Observable) {
      return (data as Observable<any>).pipe(
        switchMap(data2 => reqInfo.utils.createResponse$(() => {
          const responseOptions: ResponseOptions = this.createResponse(reqInfo, data2);
          return this.finishOptions(responseOptions, reqInfo); })));
    } else {
      return reqInfo.utils.createResponse$(() => {
        const responseOptions: ResponseOptions = this.createResponse(reqInfo, data);
        return this.finishOptions(responseOptions, reqInfo);
      });
    }
  }

  public finishOptions(responseOptions: ResponseOptions, { headers, url }: RequestInfo): ResponseOptions {
    responseOptions.statusText = getStatusText(responseOptions.status);
    responseOptions.headers = headers;
    responseOptions.url = url;
    return responseOptions;
  }

  public createResponse(reqInfo: RequestInfo, data: any): ResponseOptions {
    const dataEncapsulation = reqInfo.utils.getConfig().dataEncapsulation;
    return data ?
      {
        body: dataEncapsulation ? { data} : data,
        status: 200
      } :
      {
        body: { error: `${reqInfo.apiBase} not found`}, // todo validate
        status: 404
      };
  }

}

